"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "joppolo": {
    "b03a2449": [{
      "hkey": "e59e788a",
      "slug": "coccorino",
      "name": "Coccorino",
      "primary": true,
      "skipSearch": false
    }],
    "coccorinello": [{
      "hkey": "e59e788a",
      "slug": "coccorino",
      "name": "Coccorino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "joppolo"
    }],
    "38ec5031": [{
      "hkey": "5b17a00d",
      "slug": "joppolo",
      "name": "Joppolo",
      "primary": true,
      "skipSearch": false
    }],
    "monte-poro": [{
      "hkey": "5b17a00d",
      "slug": "joppolo",
      "name": "Joppolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;